import { useEffect, KeyboardEvent } from 'react';
import { createPortal } from 'react-dom'
import { ReactComponent as CloseIcon } from '@/assets/icons/ri-close-line.svg'
import { BookingConfirmationModalProps } from '@/components/common/Modal/types';

const ConfirmationModal = ({ body, show, onClick, rootId, contentClassName }: BookingConfirmationModalProps)  => {
  const { children } = body
  if (!show) {
    return null
  }
  const closeOnEscapeKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      onClick()
    }
  }
  useEffect(() => {
    document.body.addEventListener('keydown', () => closeOnEscapeKeyDown, false)
    return function cleanUp () {
      document.body.removeEventListener('keydown', () => closeOnEscapeKeyDown, false)
    }
  }, [])

  return createPortal(
    <div className="flex justify-center items-center fixed h-screen w-full right-auto top-auto bg-black-primary bg-opacity-20 z-50"
         onClick={(e) => {onClick(e)}} onKeyDown={closeOnEscapeKeyDown} aria-hidden>
      <div className={`flex flex-col items-stretch basis-1/4 bg-white rounded ${contentClassName}`}
           onClick={e => e.stopPropagation()} onKeyDown={closeOnEscapeKeyDown} aria-hidden>
        <div className="flex justify-end items-center w-full p-4 pb-0 gap-3 basis-1/12 text-base font-bold">
          <div role="button">
            <CloseIcon onClick={onClick()}/>
          </div>
        </div>
        <div className="flex-grow overflow-auto">
          {children}
        </div>
      </div>
    </div>,
    document.getElementById(rootId)
  )
}

export default ConfirmationModal
